export const productionMatch = /.*app.claritygo.com.*/gi
export const developmentMatch = /.*app.dev.claritygo.com.*/gi
export const localMatch = /.*localhost.*/gi